import { useEffect, useState } from 'react';
import { useAuth, useTenantsState, useLoginWithRedirect } from '@frontegg/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tenant } from '../CustomTypes';

export const useAuthCheck = () => {
  const { user, isAuthenticated } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const loginWithRedirect = useLoginWithRedirect();
  const { tenants }: { tenants: Tenant[] } = useTenantsState();
  const location = useLocation();
  const navigate = useNavigate();
  const currentRoute = location.pathname + location.search;

  useEffect(() => {
    const handleAuthentication = async () => {
      // Set loading to false if user and tenants are available
      if (user && tenants.length > 0) {
        setIsLoading(false);
        return;
      }

      if (!isAuthenticated) {
        // Save the route if the user is not authenticated
        if (currentRoute.length > 1) {
          localStorage.setItem('savedRoute', currentRoute);
          localStorage.setItem('hasNavigated', 'false');
        }
        try {
          await loginWithRedirect();
        } catch (loginError) {
          console.error('Login failed:', loginError);
        }
      } else {
        // If authenticated, handle redirect to saved route
        const savedRoute = localStorage.getItem('savedRoute');
        const hasNavigated = localStorage.getItem('hasNavigated');
        if (savedRoute && hasNavigated === 'false') {
          navigate(savedRoute);
          localStorage.setItem('hasNavigated', 'true');
          localStorage.removeItem('savedRoute');
        }
      }
    };

    handleAuthentication();
  }, [user, isAuthenticated, tenants, currentRoute, loginWithRedirect, navigate]);

  return { isAuthenticated, isLoading, user, tenants };
};
